/* error code returned when performing an action forbidden to inactive users */
export const FORBIDDEN_INACTIVE_CODE = 403030100;

export const MIN_PAYOUT_AMOUNT = 50;

export const PAYONEER_ACCOUNT_URL = "https://myaccount.payoneer.com/";
